import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "menu-selection" }
const _hoisted_2 = { class: "menu-selection--label-wr" }
const _hoisted_3 = { class: "menu-selection--label-wr--step-number" }
const _hoisted_4 = { class: "menu-selection--label-wr--step-name" }
const _hoisted_5 = { class: "menu-selection--buttons-wr" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "menu-selection"
}
const _hoisted_8 = { class: "menu-selection--select-color-wr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.isOptionalStep)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["menu-selection-wr", { 'with-icons': $setup.isSelectDesignStep }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, "Step " + _toDisplayString($props.currentStepIndex + 1) + " :", 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString($setup.menuLabel), 1)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "menu-selection--line" }, null, -1)),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.currentOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["menu-selection--button", $setup.getSelectedOptionClass(option.url)]),
                  key: option.url,
                  onClick: ($event: any) => ($setup.onClickChangeOption(option.url))
                }, _toDisplayString(`${$setup.isSelectDesignStep ? "Design" : "Option"} ${index + 1}`), 11, _hoisted_6))
              }), 128))
            ])
          ]),
          ($setup.isSelectDesignStep)
            ? (_openBlock(), _createBlock($setup["HouseParts"], { key: 0 }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    ($setup.isOptionalStep)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "menu-selection--label-wr" }, [
            _createElementVNode("p", { class: "menu-selection--label-wr--step-number" }, "Optional Step :"),
            _createElementVNode("p", { class: "menu-selection--label-wr--step-name" }, "Compare Colors")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "menu-selection--line" }, null, -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: _normalizeClass(["menu-selection--select-color gray", $setup.getSelectedOptionClass($setup.builderDemoImagesData.optionalStep[0].url)]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickChangeOption($setup.builderDemoImagesData.optionalStep[0].url)))
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["menu-selection--select-color brown", $setup.getSelectedOptionClass($setup.builderDemoImagesData.optionalStep[1].url)]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickChangeOption($setup.builderDemoImagesData.optionalStep[1].url)))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["lot-info", { 'floorplan-step': $props.currentStep === $setup.Steps.FLOORPLAN }]),
      id: "lot-info-card"
    }, [...(_cache[5] || (_cache[5] = [
      _createStaticVNode("<div class=\"lot-info--title\" data-v-c625a74a>Lot 91</div><div class=\"lot-info--text-wr\" data-v-c625a74a><div class=\"lot-info--text-wr--text\" data-v-c625a74a>Size 420 SQM</div><div class=\"lot-info--divider\" data-v-c625a74a></div><div class=\"lot-info--text-wr--text\" data-v-c625a74a>Width 14</div><div class=\"lot-info--divider\" data-v-c625a74a></div><div class=\"lot-info--text-wr--text\" data-v-c625a74a>Depth 30</div></div>", 2)
    ]))], 2)
  ], 64))
}